$(function() {
    $('[data-toggle="tooltip"]').tooltip()

    if ($('.table.table-responsive').length) {
        $('.table.table-responsive').tablesorter();
    }

    $('body').on('submit', '.pluginForm', function() {
        $('.submitBtn').after('<i class="fa-solid fa-circle-notch fa-spin fa-2x" style="position: relative; top: 6px; left: 4px; display:inline-block;"></i>');
    });
})